import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { chatTheme } from '../../styles/theme';
import { IChatBotLauncher } from './index';
import { media } from '../../styles/media';
import { ChatIconSize } from '../../store/chatSetting/types';

const backgroundColor = '#f7f8f8';
const transition = 'transition: 0.4s ease;';

const HeaderText = styled.div<{ baseSize: number }>`
  font-size: 1.2em;
  text-align: right;
  margin-right: ${props => props.baseSize}px;
`;

const HeaderIcon = styled.div<{ baseSize: number }>`
  cursor: pointer;
  color: #fff;
  border: 1px solid #fff;
  margin-right: 0.8em;
  z-index: 1000000;

  font-size: 1em;
  padding: ${props => props.baseSize * 0.1}px ${props => props.baseSize * 0.2}px;
  font-size: 1.2em;
  padding: 0.3em 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Header = styled.div<{ settingColor: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #fff;
  width: 100%;
  height: 3.2em;
	border-radius: 0.8em 0.8em 0 0;
	${transition}

  background: ${props => props.settingColor};
`;

const ImageContainer = styled.div<{ img: string; settingColor: string }>`
  background: url(${props => props.img}) center/cover no-repeat;
  width: 8em;
  height: 8em;
  margin-top: -2.6em;
  margin-left: 0.6em;
`;

const OpenChatBotContainer = styled.div<{ settingColor: string }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2em;
  width: 90%;
  margin: 0 auto;
  border: 1px solid ${chatTheme.font.primary};
  color: ${chatTheme.font.primary};
  cursor: pointer;
  ${transition}
`;

const OpenText = styled.div`
  font-size: 1em;
`;

const CaretRightIcon = styled(FontAwesomeIcon)<{ iconsize: ChatIconSize }>`
  position: absolute;
  top: ${props => (props.iconsize === ChatIconSize.SMALL ? '5px' : '6px')};
  right: 1.8em;
  color: ${chatTheme.font.primary};
  pointer-events: none;
`;

const Main = styled.div`
  display: flex;
  margin: 0.4em 0;
`;

const MessageContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-flow: column;
  margin: 0 auto;
  width: 100%;
  ${transition}
`;

const Message = styled.div<{ settingColor: string }>`
  color: ${props => props.settingColor};
`;

const Container = styled.div<{ baseSize: number; settingColor: string }>`
  font-size: ${props => props.baseSize}px;
  ${media.phone} {
    font-size: 10px;
  }
  width: 30em;
  height: 11em;
  border-radius: 0.9em 0.9em 0 0;
  position: relative;
  cursor: pointer;
	background: ${backgroundColor};

  &:hover {
    background: ${props => props.settingColor};
    border-radius: 1em 1em 0 0;
    ${Header}, ${HeaderIcon} {
      background: ${backgroundColor};
      color: ${props => props.settingColor};
    }
    ${HeaderIcon} {
      border: none;
    }

    ${Main} {
      background: ${props => props.settingColor};
    }
    ${OpenChatBotContainer} {
      border: 1px solid #fff;
    }
    ${Message}, ${OpenChatBotContainer}, ${CaretRightIcon} {
      color: #fff;
    }
  }

`;

const titleMessage = 'チャットボットで質問はこちら';
const mainMesage = 'お気軽にお問合せください';

const StyleC: React.FC<IChatBotLauncher> = ({
  baseFontSize,
  color,
  launcherImageUrl,
  showChatBot,
  toggleCloseDialog
}) => {
  const closeDialog = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    toggleCloseDialog();
  };
  const baseSize = baseFontSize;
  const iconSize =
    baseFontSize === 10 ? ChatIconSize.SMALL : ChatIconSize.LARGE;

  console.log(iconSize);
  const settingColor = color;
  const toggleChatBot = (e: any) => {
    showChatBot();
  };
  return (
    <Container
      baseSize={baseSize}
      settingColor={settingColor}
      onClick={toggleChatBot}
    >
      <Header settingColor={settingColor}>
        <HeaderText baseSize={baseSize}>{titleMessage}</HeaderText>
        <HeaderIcon
          id="chatbot-close-btn"
          baseSize={baseSize}
          onClick={e => closeDialog(e)}
        >
          <FontAwesomeIcon icon={faTimes} />
        </HeaderIcon>
      </Header>

      <Main>
        <ImageContainer img={launcherImageUrl} settingColor={settingColor} />

        <MessageContainer>
          <Message settingColor={settingColor}>{mainMesage}</Message>
          <OpenChatBotContainer settingColor={settingColor}>
            <OpenText>チャットボットをひらく</OpenText>
            <CaretRightIcon icon={faCaretRight} iconsize={iconSize} />
          </OpenChatBotContainer>
        </MessageContainer>
      </Main>
    </Container>
  );
};

export default StyleC;
